import React from 'react';
import { resolveSectionIconSrc } from './sectionIconCatalog';
import './sectionMenuIcon.css';

interface SectionMenuIconProps {
  codigo?: string | null;
  descripcion?: string | null;
  src?: string | null;
  className?: string;
  color?: string;
}

const SectionMenuIcon: React.FC<SectionMenuIconProps> = ({
  codigo,
  descripcion,
  src,
  className = '',
  color,
}) => {
  const iconSrc = src || resolveSectionIconSrc(codigo, descripcion);
  if (iconSrc) {
    return (
      <span
        aria-hidden='true'
        className={['section-menu-icon', className].filter(Boolean).join(' ')}
        style={{
          ['--section-icon-url' as string]: `url("${iconSrc}")`,
          ...(color ? { backgroundColor: color } : {}),
        }}
      />
    );
  }

  if (codigo) {
    return <i aria-hidden='true' className={codigo} style={color ? { color } : undefined} />;
  }

  return null;
};

export default SectionMenuIcon;
